// Re-exports from unified color system
import { PRIMITIVE_COLORS, SEMANTIC_COLORS, COMPONENT_COLORS } from '../residentColors';

export const NOTIFICATION_COLORS = {
  screenBackground: SEMANTIC_COLORS.background.primary,
  cardBackground: SEMANTIC_COLORS.background.secondary,
  cardBackgroundRead: 'transparent',
  cardBorderRead: PRIMITIVE_COLORS.gray850,
  avatarBackground: PRIMITIVE_COLORS.white10,
  circleIconBackground: PRIMITIVE_COLORS.gray700,
  borderPrimary: PRIMITIVE_COLORS.resioBlueBorder,
  borderSecondary: PRIMITIVE_COLORS.gray700,
  modalBorder: PRIMITIVE_COLORS.resioBlueBorder,
  textPrimary: SEMANTIC_COLORS.text.primary,
  textSecondary: PRIMITIVE_COLORS.gray400,
  textTertiary: PRIMITIVE_COLORS.gray500,
  unreadDot: COMPONENT_COLORS.notification.unreadDot,
  linkBlue: PRIMITIVE_COLORS.resioBlueLight,
  buttonPrimary: PRIMITIVE_COLORS.resioBlue,
  iconDefault: PRIMITIVE_COLORS.gray400,
  iconMuted: PRIMITIVE_COLORS.gray500,
  iconInactive: '#9CA3AF',
  refreshTint: SEMANTIC_COLORS.text.primary,
  switchTrackOff: COMPONENT_COLORS.toggle.trackOff,
  switchTrackOn: COMPONENT_COLORS.toggle.trackOn,
  switchThumb: COMPONENT_COLORS.toggle.thumb,
  switchTrackOnDesktop: '#009688',
} as const;

export const NOTIFICATION_AVATAR = { size: 46, borderRadius: 23, iconSize: 20 } as const;
export const NOTIFICATION_AVATAR_DESKTOP = { size: 36, borderRadius: 18 } as const;
export const NOTIFICATION_UNREAD_DOT = { size: 10, borderRadius: 5 } as const;
export const NOTIFICATION_UNREAD_DOT_DESKTOP = { size: 12, borderRadius: 6, offsetTop: -2, offsetLeft: -2 } as const;

export type NotificationColor = keyof typeof NOTIFICATION_COLORS;
